import { render, staticRenderFns } from "./ConfigLobby.vue?vue&type=template&id=ba2e54b4&scoped=true&"
import script from "./ConfigLobby.vue?vue&type=script&lang=js&"
export * from "./ConfigLobby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2e54b4",
  null
  
)

export default component.exports